import { render, staticRenderFns } from "./tobacco-echarts-header.vue?vue&type=template&id=275c3285&scoped=true&"
import script from "./tobacco-echarts-header.vue?vue&type=script&lang=js&"
export * from "./tobacco-echarts-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c3285",
  null
  
)

export default component.exports